module.exports = __webpack_public_path__ + "static/media/rock.badcc27d.png";